import React from 'react';
import { siteUrl } from '../utils/site';

// Wherever users pay (PLAN-6, WEB-10): Paddle is the reseller and merchant of record, and the terms and the refund policy
// are one tap away. Quiet by design: the colours come from the place it sits in (`className`), gray by default.
// `as="span"` where it sits inside a paragraph (PlanLine).
const PaymentsNote: React.FC<{ className?: string; as?: 'p' | 'span' }> = ({ className, as: Tag = 'p' }) => (
  <Tag className={className ?? 'text-xs text-gray-500 dark:text-gray-400'} data-testid="payments-note">
    Payments are handled by Paddle.com, our reseller.{' '}
    <a href={siteUrl('/terms')} target="_blank" rel="noopener noreferrer" className="underline underline-offset-2 hover:opacity-80">Terms</a>
    {' · '}
    <a href={siteUrl('/refunds')} target="_blank" rel="noopener noreferrer" className="underline underline-offset-2 hover:opacity-80">Refund policy</a>
  </Tag>
);

export default PaymentsNote;
